// extracted by mini-css-extract-plugin
module.exports = {"root":"Board__root","card":"Board__card"};